import React, { FC, useCallback, useMemo, useState } from 'react';
import { SwipeDialogContainer } from './_Container/SwipeDialogContainer';
import { ISwiper, Swiper } from '@src/atoms/Swiper/Swiper';

import styles from './SwipeDialog.scss';
import { Box } from '@src/atoms/Box';
import { Modal } from '@src/core/Modal';
import { ISwipeDialogContext, SwipeDialogProps } from './models';
import { SwipeDialogContext } from './context';

export const SwipeDialog: FC<SwipeDialogProps> = ({
  onClose,
  slideClasses,
  slideStyle,
  className,
  style,
  backdropClasses,
  backdropStyle,
  isOpen = true,
  ...props
}) => {
  const [swipeController, setSwipeController] = useState<ISwiper | null>(null);

  const onBackdropClick = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleSlideChangeTransitionEnd = (swipeController: ISwiper) => {
    if (swipeController?.activeIndex === 0) {
      swipeController.once('destroy', onBackdropClick);
      swipeController.destroy();
    }
  };

  const values = useMemo<ISwipeDialogContext>(() => ({ swipeController }), [swipeController]);

  const sliders = useMemo(
    () => [
      {
        id: 'transparent',
        content: <Box bgColor={'basicTransparent'} className={styles.transparentContainer} />,
      },
      {
        id: 'container',
        content: <SwipeDialogContainer {...props} />,
      },
    ],
    [props],
  );

  return (
    <Modal
      open={isOpen}
      backdropClasses={backdropClasses}
      backdropStyle={backdropStyle}
      onBackdropClick={onBackdropClick}
    >
      <SwipeDialogContext.Provider value={values}>
        <Swiper
          className={className}
          style={style}
          slideClasses={slideClasses}
          slideStyle={slideStyle}
          slides={sliders}
          direction={'vertical'}
          slidesPerView={1}
          initialSlide={1}
          onSwiper={setSwipeController}
          onSlideChangeTransitionEnd={handleSlideChangeTransitionEnd}
        />
      </SwipeDialogContext.Provider>
    </Modal>
  );
};
